import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactLoading from 'react-loading';
import { primarycolor } from "../Utils/colors";
import { Changepassurl } from "./../Utils/urls";
import styles from "./../Hostels/houses.module.css";
import styless from "./style.module.css";
import { FaStarOfLife, FaUser, FaClock, FaCheckCircle, FaUpload } from 'react-icons/fa';
import { Link, useNavigate } from "react-router-dom";
import { getsessionuser} from './../Utils/sessions';
import Universalheader from "../Headers/universalheader";
import { Modal } from "@mui/material";
import SignIn from "../Common/login";



let color = "white";
let type = "spokes";


const Security = () => {

    const navigate = useNavigate();


    const sessionuser = getsessionuser();
    const [user, setuser] = useState(sessionuser);
    const [showlogin, setshowlogin] = useState(false);


    const [opassword, setopassword] = useState('');
    const [npassword, setnpassword] = useState('');
    const [cpassword, setcpassword] = useState('');

    const [profileimage, setprofileimage] = useState('');

    const [progress, setprogress] = useState(false);
    const [loading, setloading] = useState(false);
    const [error, seterror] = useState('');
    const [error2, seterror2] = useState('');
    const [successdiv, setsuccessdiv] = useState(false);




    //save user password
    const savepassword = () => {
        setprogress(true)
        seterror(null)
        if (!npassword || !opassword || !cpassword) {
            seterror("fill all fields")
            setprogress(false)
        } else if (npassword !== cpassword) {
            seterror("The new passwords do not match")
            setprogress(false)
        }
        else {
            seterror(null)
            axios.post(Changepassurl, {
                email: user.email,
                password: cpassword,
                currentpassword: opassword
            }).then(response => {
                setprogress(false)
                if (!response.data.message) {
                    setsuccessdiv(true)
                    setTimeout(() => {
                        setsuccessdiv(false)
                    }, 3000);
                } else {
                    seterror(response.data.message)
                }
                // 
            }).catch(error => {
                setprogress(false)
                seterror("Sorry an error occurred,try again later");


            });
        }
    }



    const onsuccesslogin = () => {
        setshowlogin(false)
    }


    return (
        <div className={styles.container}>
            <div className={styles.topheader} style={{ paddingBottom: 100 }}>
                <Universalheader refresh={showlogin} />
                <Modal
                    open={showlogin}
                    onClose={() => setshowlogin(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <SignIn onsuccesslogin={onsuccesslogin} />
                </Modal>
                <div className={styles.advertisediv}>
                    <FaStarOfLife color={primarycolor} size={15} />
                    <Link to="">
                        <a href="https://play.google.com/store/apps/details?id=com.eazistey.eazistey">List on Eazistey</a>
                    </Link>
                </div>
                <div className={styles.housenamediv}>
                    <div className={styles.housenamehead}>{user?.username}</div>
                    <div>

                    </div>
                </div>
                <div className={styles.linksdiv}>
                    <Link to="/">
                        <a>Home  /</a>
                    </Link>

                    <a onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>back  /</a>

                    <Link to="">
                        <a>{user?.username}  /</a>
                    </Link>

                </div>
                <div className={styles.bodydiv}>
                    <div className={styles.housedetailsdiv}>
                            <div>
                                <div style={{ fontWeight: "bold", fontSize: 15 }}>Password & Security</div>
                                <br />
                                <div className={styless.inputdiv}>
                                    Old Password<br />
                                    <input name="old" value={opassword} type="password" onChange={(e) => setopassword(e.target.value)} />
                                </div>
                                <div className={styless.inputdiv}>
                                    New Password<br />
                                    <input name="new" value={npassword} type="password" onChange={(e) => setnpassword(e.target.value)} />
                                </div>
                                <div className={styless.inputdiv}>
                                    Confirm New Password<br />
                                    <input name="cnew" value={cpassword} type="password" onChange={(e) => setcpassword(e.target.value)} />
                                </div>
                                {error && <div style={{ color: "red", fontSize: 10 }}>{error}</div>}
                                {successdiv && <div className={styless.successdiv}><FaCheckCircle color={"green"} /> Saved</div>}
                                <button onClick={savepassword} className={styless.savebutton}>{progress ? <ReactLoading type={type} color={color} height={25} width={20} /> : "Save"}</button>
                            </div>
                        
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Security;